import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Link from 'common/components/atoms/Link';
import { Button } from 'common/components/atoms';
import LoadingSvg from 'common/images/LoadingSvg';
import { checkEmpty, checkEmail, renderInputField } from '../../common/OnboardingComponents/form-fields';
import InputField from '../../common/components/atoms/InputField';

const CheckboxField = styled(InputField).attrs({ type: 'checkbox' })`
  label {
    color: ${props => props.theme.colors.black};
    font-weight: 300;
  }
`;

const SignInButton = styled(Button)`
  width: 100%;
  margin: 3px 0 10px;
`;

function LoginForm(props) {
  const { loggingIn, handleSubmit, location } = props;
  const { t } = useTranslation();

  const getSSORedirectState = () => {
    // First try to get from state (client-side navigation), triggered by PrivateRoute
    if (location.state) {
      return {
        pathname: '/sso',
        state: location.state
      };
    }

    // If no state, but we have pathname/search, use those, triggered when direct url navigation happens
    if (location.pathname !== '/login' && location.pathname !== '/sso') {
      return {
        pathname: '/sso',
        state: {
          pathname: location.pathname,
          search: location.search
        }
      };
    }

    // Default case - no destination specified
    return {
      pathname: '/sso'
    };
  };

  // Examples of variables & pluralization usage if needed:
  // const welcomeMsg = t('welcome');
  // const greetingMsg = t('greeting', { name: 'Alex' });
  // const itemCountMsg = t('itemCount', { count: 3, item: t('item', { count: 3 }) });

  return (
    <form name="form" onSubmit={handleSubmit}>
      <Field
        name="username"
        component={renderInputField}
        type="text"
        validate={[checkEmpty, checkEmail]}
        label={t('login.email')}
      />
      <Field
        name="password"
        component={renderInputField}
        type="password"
        validate={[checkEmpty]}
        label={t('login.password')}
      />
      <Field
        name="remember_me"
        component={CheckboxField}
        label={t('login.rememberMe')}
        labelSide="right"
      />

      <div className="form-group">
        {/* eslint-disable */}
        <SignInButton id="LoginPage-Button-SignIn">
          {t('login.signIn')}
        </SignInButton>
        {loggingIn && (
          <div className="ps-align-center" id="LoginPage-Loader">
            <LoadingSvg />
          </div>
        )}
        <Link to={getSSORedirectState()}>
          {t('login.sso')}
        </Link>
        <Link
          style={{ width: '100%' }}
          to="/forgot_password"
          id="LoginPage-Link-ForgotPassword"
        >
          {t('login.forgotPassword')}
        </Link>

        <div className="warning-msg" id="LoginPage-Message-Warning">
          <p>{t('login.warning.title')}</p>
          <p>{t('login.warning.message')}</p>
        </div>

        {/* Optional debug/example:
        <p>{welcomeMsg}</p>
        <p>{greetingMsg}</p>
        <p>{itemCountMsg}</p>
        */}
      </div>
    </form>
  );
}

function mapStateToProps(state) {
  const { loggingIn } = state.authentication;
  return {
    loggingIn,
  };
}

const ReduxLoginForm = reduxForm({ form: 'Login' })(LoginForm);

export default connect(mapStateToProps)(withRouter(ReduxLoginForm));